export enum SearchOption {
  raNoOrResId = 0,
  phoneNumber = 1,
  email = 2,
}
